<template lang="pug">
#app(:class='[layoutClassName]', ref='app' v-loading="loading")
  #header
    comp-header(v-if='!$isMobile')
    comp-header-mobile(
      v-if='$isMobile',
      :isMobileVerticalLayout='isMobileVerticalLayout',
      :isMobileHorizontalLayout='isMobileHorizontalLayout'
    )
  #content
    #carousel(v-if="isTuWenLiving")
      comp-carousel(ref='carousel')

    #player(v-if="!isTuWenLiving")
      comp-player(v-if='!$isMobile', ref='player')
      comp-player-mobile(v-if='$isMobile', ref='player')
    #message
      comp-message(
        ref='message',
        :isMobileVerticalLayout='isMobileVerticalLayout',
        :isMobileHorizontalLayout='isMobileHorizontalLayout'
      )
</template>

<script>
import LibGenerateTestUserSig from '@/utils/lib-generate-test-usersig.min.js';
import compHeader from '@/components/comp-header/index';
import compHeaderMobile from '@/components/comp-header/index-mobile';
import compPlayer from '@/components/comp-player/index';
import compPlayerMobile from '@/components/comp-player/index-mobile';
import compMessage from '@/components/comp-message';
import compCarousel from '@/components/comp-carousel/index';

import layout from './layout.js';
import {
  SET_SDK_APP_ID,
  SET_USER_SIG,
  SET_PLAYER_DOMAIN,
  SET_ROOM_ID,
  SET_ROOM_NAME,
  UPDATE_USER_INFO,
  SET_ANCHOR_USER_ID,
  SET_IS_SUPPORT_WEBRTC,
  UPDATE_LINE_TYPE,
  UPDATE_SEND_MSG_ENABLE,
  UPDATE_CHAT_ROOM_ENABLE,
  UPDATE_LIVE_INFO,
  UPDATE_PLAY_STATE,
  SET_PLAY_URL,
  SET_PLAYER_ISACTIVE,
  SET_LIVE_TYPE,
  SET_VIEW_SUM,
  SET_LIVE_GRAPHIC,
} from '@/constants/mutation-types';
import { LINE_TYPE } from '@/constants/room';
import {
  sdkAppId,
  expireTime,
  secretKey,
  playerDomain,
  userInfo,
  roomInfo,
  anchorUserInfo,
} from '@/config/basic-info-config';
import { mapState, mapGetters } from 'vuex';

import { queryLiveById, getCurrUserInfo, addWatchHistoryCount } from '@/api/live';
import { getUrlParams } from '@/utils/utils';


// import TRTC from 'trtc-js-sdk';
export default {
  name: 'App',
  mixins: [layout],
  data() {
    return {
      loading: true,
      watchCountLoopTimer: null,  // 轮询定时器
      initWatchCountLoopTime: 1 * 1e3,  // 间隔时间
      watchCountLoopTime: null,  // 间隔时间
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.player.userInfo,
      roomId: state => state.player.roomId,
    }),
    ...mapGetters('player', {
      isTuWenLiving: 'isTuWenLiving'
    }),
  },
  components: {
    compHeader,
    compHeaderMobile,
    compPlayer,
    compPlayerMobile,
    compMessage,
    compCarousel,
  },
  methods: {
    // 处理是否支持 webRTC
    async handleSupportWebRTC() {
      // const supportResult = await TRTC.checkSystemRequirements();
      // const { isWebRTCSupported, isH264DecodeSupported } = supportResult.detail;
      // if (!isWebRTCSupported || !isH264DecodeSupported) {

      console.log('采用【线路三：标准直播】播放，且不可切换线路');

      this.$store.commit(`player/${SET_IS_SUPPORT_WEBRTC}`, false);
      this.$store.commit(`player/${UPDATE_LINE_TYPE}`, LINE_TYPE.CDN);
      // }
    },
    // 处理页面数据
    async handlePlayerInfo(myRoomId) {
      if (sdkAppId === '' || secretKey === '') {
        console.error(`${this.$t('basic.Please configure your SDKAPPID')}\r\n\r\nconfig/basic-info-config.js`);
      }

      let liveInfo = null; let currUserInfo = {};

      try {
        this.loading = true;
        liveInfo = await this.getLiveInfo(myRoomId);
        this.closeLoading();
        this.initWechatShare(liveInfo);
      } catch (error) {
        this.closeLoading();
      }

      if (!liveInfo) {
        this.$message.warning('获取直播间信息出错');
        return false;
      }

      const  { memberInfo, liveName, chatRoomOn, type: liveType } = liveInfo;

      // document.title = `新快直播|${liveName}`;
      document.title = `${liveName}`;

      this.$store.commit(`player/${UPDATE_LIVE_INFO}`, liveInfo);
      this.$store.commit(`player/${SET_ROOM_NAME}`, liveName);
      this.$store.commit(`player/${SET_LIVE_TYPE}`, liveType);
      this.$store.commit(`player/${SET_LIVE_GRAPHIC}`, liveInfo.liveGraphic);

      this.setBaseLiveInfo(liveInfo, false);

      const generator = new LibGenerateTestUserSig(
        sdkAppId,
        secretKey,
        expireTime,
      );

      try {
        const _user = await this.getUserInfo();
        console.log(_user, '接口请求，当前用户');

        currUserInfo = Object.assign({}, userInfo, {
          // 用户ID
          userId: _user.username,
          // 用户昵称
          userName: _user.fullname,
          // 用户头像
          userAvatar: '',

          tenantId: _user.tenantId,
        })
      } catch (error) {
        currUserInfo = userInfo;
      }

      const userSig = generator.genTestUserSig(currUserInfo.userId);

      // 注意：请优先设置 sdkAppId 信息
      this.$store.commit(`player/${SET_SDK_APP_ID}`, sdkAppId);
      this.$store.commit(`player/${SET_USER_SIG}`, userSig);

      // 直播房间ID
      this.$store.commit(`player/${SET_ROOM_ID}`, myRoomId);

      // 设定主播ID
      this.$store.commit(`player/${SET_ANCHOR_USER_ID}`, memberInfo.USERID || anchorUserInfo.userId);

      // 设置当前用户
      this.$store.commit(`player/${UPDATE_USER_INFO}`, {
        userId: currUserInfo.userId,
        userName: currUserInfo.userName,
        userAvatar: currUserInfo.userAvatar,
        tenantId: currUserInfo.tenantId || '',
      });
      console.log('系统当前用户信息=>', currUserInfo)


      // anonymous:true 匿名/实名
      // 默认，未登录
      if (currUserInfo.userId === 'user_audience') {
      // 是否开启聊天室
        this.$store.commit(`player/${UPDATE_CHAT_ROOM_ENABLE}`, true);

        // 是否能发送消息
        this.$store.commit(`player/${UPDATE_SEND_MSG_ENABLE}`, false);
      } else {
        // 是否开启聊天室
        this.$store.commit(`player/${UPDATE_CHAT_ROOM_ENABLE}`, chatRoomOn === true);

        // 是否能发送消息
        this.$store.commit(`player/${UPDATE_SEND_MSG_ENABLE}`, chatRoomOn === true);

        // 是否开启聊天室
        // this.$store.commit(`player/${UPDATE_CHAT_ROOM_ENABLE}`, true);
        // 是否能发送消息
        // this.$store.commit(`player/${UPDATE_SEND_MSG_ENABLE}`, true);
      }
    },
    // 退出直播间
    async handleExit() {
      // todo: 处理退出直播间
    },
    // 退出登录
    async handleLogout() {
      // todo: 处理退出登录
    },

    // 获取直播信息
    getLiveInfo(liveId) {
      return new Promise((resolve, reject) => {
        queryLiveById({
          liveId,
        })
          .then((res) => {
            if (res.code === 200 && res.data) {
              const { data } = res;
              if (typeof(data.coverImages) === 'string') {
                try {
                  data.coverImages = JSON.parse(data.coverImages);
                } catch (error) {
                  data.coverImages = [];
                }
              }

              if (typeof(data.logoImages) === 'string') {
                try {
                  data.logoImages = JSON.parse(data.logoImages);
                } catch (error) {
                  data.logoImages = [];
                }
              }

              if (typeof(data.memberInfo) === 'string') {
                try {
                  data.memberInfo = JSON.parse(data.memberInfo);
                } catch (error) {
                  data.memberInfo = {};
                }
              }

              resolve(data);
            } else {
              reject();
            }
          })
          .catch(() => {
            reject();
          });
      });
    },

    // 获取当前用户信息
    getUserInfo() {
      return new Promise((resolve, reject) => {
        getCurrUserInfo()
          .then((res) => {
            if (res.code === 200) {
              const { data } = res;
              resolve(data);
            } else {
              reject()
            }
          })
          .catch((e) => {
            reject();
          });
      });
    },

    // 轮询获取观看数
    getWatchCount(liveId) {
      if (this.watchCountLoopTimer) window.clearInterval(this.watchCountLoopTimer);

      this.watchCountLoopTimer = window.setInterval(async () => {
        const liveInfo = await this.getLiveInfo(liveId);
        if (liveInfo) {
          this.setBaseLiveInfo(liveInfo, true);
        }
      }, this.watchCountLoopTime)
    },

    setBaseLiveInfo(liveInfo, isLooping) {
      const currTime = new Date().getTime();
      const  { isActive, urlEntity, videoEntity } = liveInfo;

      let playUrl = ''; let urlArr = [];

      if (liveInfo.isBan === true) {
        liveInfo._liveStatus = '-99';
      } else if (
        // 根据时间来判断
        // 判断预告
        liveInfo.startTime && currTime - new Date(liveInfo.startTime).getTime() < 0
      ) {
        // 预告
        liveInfo._liveStatus = '3';
      } else {
        liveInfo._liveStatus = `${isActive}`;
      }

      if (liveInfo._liveStatus === '2') { // 直播结束，回放
        if (!videoEntity || !videoEntity.url) {
          // 直播回放还没生成
          playUrl = '';
        } else {
          console.log('拿到回放')

          // 有更换过的，拿更换的
          playUrl = videoEntity.customUrl || videoEntity.url;
          urlArr = (playUrl.substring(playUrl.indexOf('//') + 2, playUrl.lastIndexOf('/'))).split('/');
        }

        // 先判断轮询时间有无修改过，有改过，则不用再改了
        if (this.watchCountLoopTime === this.initWatchCountLoopTime) {
          // 直播时间已经结束，修改轮询间隔时间
          if (
            liveInfo.endTime && currTime - new Date(liveInfo.endTime).getTime() > 3.6e6 * 24
          ) {
            // 已超过 24 小时
            this.watchCountLoopTime = 10 * 60 * 1e3
          } else if (
            liveInfo.endTime && currTime - new Date(liveInfo.endTime).getTime() > 3.6e6 * 6
          ) {
            // 已超过 6 小时
            this.watchCountLoopTime = 5 * 60 * 1e3
          } else if (
            liveInfo.endTime && currTime - new Date(liveInfo.endTime).getTime() > 3.6e6 * 1
          ) {
            // 已超过 1 小时
            this.watchCountLoopTime = 1 * 60 * 1e3
          }  else {
            // 改成 10 秒轮询一次
            this.watchCountLoopTime = 10 * 1e3
          }
          // 重新开始轮询
          this.getWatchCount(this.roomId);
        }
      } else if (liveInfo._liveStatus === '0' || liveInfo._liveStatus === '3' || liveInfo._liveStatus === '-99') {  // 未开播、预告、被禁用
        playUrl = '';
      } else {
        playUrl = urlEntity.hlsHttpsPlayUrl;
        urlArr = (playUrl.substring(playUrl.indexOf('//') + 2, playUrl.indexOf('.m3u8'))).split('/');
      }

      if (!isLooping) {
        console.log('直播信息:', liveInfo, urlArr);
        console.log('直播链接:', playUrl);
      }

      // 直播域名
      this.$store.commit(`player/${SET_PLAYER_DOMAIN}`, urlArr[0] || this.playerDomain);
      // 直播观看人数
      this.$store.commit(`player/${SET_VIEW_SUM}`, liveInfo.viewCount || 0);
      this.$store.commit(`player/${SET_PLAY_URL}`, playUrl);
      this.$store.commit(`player/${SET_PLAYER_ISACTIVE}`, liveInfo._liveStatus);


      // 直播中
      // this.$store.commit(`player/${SET_PLAY_URL}`, 'https://gctxyc.liveplay.myqcloud.com/gc/tyhjtynl_1/index.m3u8?contentid=2820180516001');
      // this.$store.commit(`player/${SET_PLAYER_ISACTIVE}`, '1');

      // 直播已结束
      // this.$store.commit(`player/${SET_PLAY_URL}`, 'https://gctxyc.liveplay.myqcloud.com/gc/tyhjtynl_1/index.m3u8?contentid=2820180516001');
      // this.$store.commit(`player/${SET_PLAYER_ISACTIVE}`, '2');

      // this.$store.commit(`player/${SET_PLAY_URL}`, '');
      // this.$store.commit(`player/${SET_PLAYER_ISACTIVE}`, '1');
    },

    // 初始化微信分享
    initWechatShare(liveInfo) {
      // let curPath = window.location.href;
      // curPath = curPath.substr(0, curPath.lastIndexOf('/') + 1);

      window.wechatShare({
        title: liveInfo.liveName,
        desc: liveInfo.liveDesc,
        imgUrl: liveInfo.logoImages[0]?.url,
      }, (flag, _wx) => {

      });
    },

    closeLoading() {
      document.body.style.visibility = 'visible';
      this.loading = false;
    }
  },
  created() {
    const self = this;
    this.loading = true;
    // 判断是否支持 webrtc, 不支持 webrtc 的网页采用【线路三：标准直播】播放，且不可切换线路
    this.handleSupportWebRTC();

    // 获取当前url参数
    const locaParams = getUrlParams(window.location.href);
    const myRoomId = (locaParams && locaParams.liveId) || roomInfo.roomId;

    // 初始化赋值轮询时间
    this.watchCountLoopTime = this.initWatchCountLoopTime;

    // 处理页面数据
    window.trsGetToken(() => {
      self.handlePlayerInfo(myRoomId);

      // 点击量锚点
      addWatchHistoryCount(myRoomId);
    });

    setTimeout(() => {
      // 开始轮询
      this.getWatchCount(myRoomId);
    }, 5 * 1000)

    // 处理监听事件
    this.$eventBus.$on('exit', this.handleExit);
    this.$eventBus.$on('logout', this.handleLogout);
    this.$eventBus.$on('showLoginCard', this.handleShowLoginCard);
  },
  beforeDestroy() {
    this.$eventBus.$off('exit', this.handleExit);
    this.$eventBus.$off('logout', this.handleLogout);
    this.$eventBus.$off('showLoginCard', this.handleShowLoginCard);
    if (this.watchCountLoopTimer) window.clearInterval(this.watchCountLoopTimer);
  },
};
</script>

<style lang="stylus">
@import '~assets/style/black-element-ui.styl';
@import './index.styl';

.el-loading-mask{
  background-color: rgba(255,255,255,1);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  overflow: auto;
}

// PC页面布局
#app.app-layout {
  // background-color: $backgroundColor;
  color: $fontColor;
  background-image: linear-gradient(180deg, $highLightColor, #fff);

  #header {
    width: 100%;
    height: 52px;
    background-color: $themeColor;
  }

  #content {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    top: 52px;
    display: flex;


    top: 60px;
    width: 1200px;
    // height: 1400px;
    background-color: #fff;
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);
    left: 50%;
    margin-left: -600px;
    max-height: 800px;

    #carousel,
    #player {
      height: 100%;
      // flex-grow: 1;
      flex: 1;
      background-color: $backgroundColor;
      overflow hidden
    }

    #message {
      width: 38%;
      min-width: 300px;
      max-width: 550px;
      height: 100%;
      background-color: $IMThemeColor;
    }
  }
}

// 移动端竖屏布局
#app.mobile-vertical-layout {
  background-color: $IMThemeColor;
  color: $fontColor;
  display: flex;
  flex-direction: column;

  #header {
    width: 100%;
    // max-height 130px
    background-color: $themeColor;
    margin-bottom: 5px;
  }

  #content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    #carousel,
    #player {
      width: 100%;
      height: 250px;

      // 改成16:9的大小

      overflow: hidden;
      height: 0px;
      padding-bottom: 56.25%;
      position: relative;
      background-color: $backgroundColor;
      overflow hidden
    }

    #message {
      background-color: $IMThemeColor;
      flex-grow: 1;
      position: relative;
    }
  }

  &.isTuWenLiving{
    #carousel{
      height: 125px!important
      .mySwiper{
        position: absolute;
      }

      .swiper-button-prev:after, .swiper-button-next:after{
        font-size: 20px;
      }
    }
  }
}

// 移动端横屏布局
#app.mobile-horizontal-layout {
  color: $horizontalLayoutFontColor;

  #header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    // left 20px
    // right 0
    z-index: 10;
    transform: translateZ(100px);
  }

  #content {
    width: 100%;
    height: 100%;
    position: relative;

    #carousel,
    #player {
      width: 100%;
      height: 100%;
      background-color: $backgroundColor;
      overflow hidden
    }

    #message {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      // left 20px
      // right 0
      height: 70%;
      pointer-events: none;
      transform: translateZ(100px);
    }
  }
}

/* 观看端，不能发送图文消息 */
.tuwen-pc-container{
  .content-bottom,
  .divider{
    display none!important;
  }
}
</style>
